/* global STAGE */

const rollbarConfig = {
	accessToken: '3c5af95d57904a6681be5de950aa552a',
	captureUncaught: false,
	captureUnhandledRejections: false,
	payload: {
		environment: STAGE
	},
	checkIgnore: window["rollbarIgnore"],
};

export default {
	install: (Vue) => {
		const Rollbar = (window && window["rollbar"] && window["rollbarIgnore"]) ? new window["rollbar"] : null;
		const rollbar = Rollbar ? new Rollbar(rollbarConfig) : null;

		Vue.config.errorHandler = function (error, vm, info) {
			if (STAGE === 'prd') {
				rollbar.error(error);
			}

			throw error;
		};
	}
};
